import { render } from "./AccessManagementDrawer.vue?vue&type=template&id=50cf4dca"
import script from "./js/accessManagementDrawer.js?vue&type=script&lang=js&external"
export * from "./js/accessManagementDrawer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__